document.addEventListener("DOMContentLoaded", async (e) => {
  document.querySelectorAll('a[href^="#hbspt-form-anchor"]').forEach(anchor => {
    anchor.addEventListener('click', function (e) {
      e.preventDefault();

      const target = document.querySelector(this.getAttribute('href'));
      if (target) {
        const offset = 300;
        const targetPosition = target.getBoundingClientRect().top + window.pageYOffset - offset;

        window.scrollTo({
          top: targetPosition,
          behavior: 'smooth'
        });
      }
    });
  });

  // Smooth-scroll for every other same-page anchor (e.g. buttons linking to "#shopify-section-…" or a
  // custom-liquid anchor), offset by the sticky header so the target isn't hidden under it.
  // #MainContent (skip link) and the login page's #login/#Recover toggles keep their native behaviour.
  document.addEventListener('click', (e) => {
    const anchor = e.target.closest('a[href^="#"]');
    if (!anchor || e.defaultPrevented || anchor.hasAttribute('aria-controls')) return;

    const id = decodeURIComponent(anchor.getAttribute('href').slice(1));
    if (!id || ['MainContent', 'login', 'Recover'].includes(id) || id.startsWith('hbspt-form-anchor')) return;

    const target = document.getElementById(id);
    if (!target) return;

    e.preventDefault();
    const header = [...document.querySelectorAll('.shopify-section-group-header-group')]
      .find(section => ['sticky', 'fixed'].includes(getComputedStyle(section).position));
    const offset = header ? header.offsetHeight : 0;

    window.scrollTo({
      top: target.getBoundingClientRect().top + window.pageYOffset - offset,
      behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'
    });
    history.pushState(null, '', '#' + id);
  });

  // Country Popup
  if (sessionStorage.getItem('countryPopupShown')) return;

  try {
    const ip = await fetch('https://ipapi.co/ip/').then(res => res.text());
    const country = await fetch(`https://ipapi.co/${ip}/country_name/`).then(res => res.text());

    if (document.body.classList.contains('template-collection-tangible-collection')) {
      openCountrypopupTangible(country);
    } else {
      openCountrypopup(country);
    }
  } catch (err) {
    console.error('Geo lookup failed:', err);
  }
});

function openCountrypopup(userCountry) {
  const europeanCountries = [
  'Albania', 'Andorra', 'Armenia', 'Austria', 'Azerbaijan', 'Belarus', 'Belgium',
  'Bosnia and Herzegovina', 'Bulgaria', 'Croatia', 'Cyprus', 'Czech Republic',
  'Denmark', 'Estonia', 'Finland', 'France', 'Georgia', 'Germany', 'Greece',
  'Hungary', 'Iceland', 'Ireland', 'Italy', 'Kazakhstan', 'Kosovo', 'Latvia',
  'Liechtenstein', 'Lithuania', 'Luxembourg', 'Malta', 'Moldova', 'Monaco',
  'Montenegro', 'Netherlands', 'North Macedonia', 'Norway', 'Poland', 'Portugal',
  'Romania', 'Russia', 'San Marino', 'Serbia', 'Slovakia', 'Slovenia', 'Spain',
  'Sweden', 'Switzerland', 'Turkey', 'Ukraine', 'Vatican City'
];

  setTimeout(() => {
    if (europeanCountries.includes(userCountry)) {
      const popupHTML = `
        <div class="countryPopup open">
          <div class="innerContainer">
            <span style="cursor:pointer;">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48" {% if class %}class="{{ class }}"{% endif %}>
            	<path d="M 38.982422 6.9707031 A 2.0002 2.0002 0 0 0 37.585938 7.5859375 L 24 21.171875 L 10.414062 7.5859375 A 2.0002 2.0002 0 0 0 8.9785156 6.9804688 A 2.0002 2.0002 0 0 0 7.5859375 10.414062 L 21.171875 24 L 7.5859375 37.585938 A 2.0002 2.0002 0 1 0 10.414062 40.414062 L 24 26.828125 L 37.585938 40.414062 A 2.0002 2.0002 0 1 0 40.414062 37.585938 L 26.828125 24 L 40.414062 10.414062 A 2.0002 2.0002 0 0 0 38.982422 6.9707031 z"/>
              </svg>
            </span>
            <p>Hi there!</p>
            <p>It looks like you're visiting from Europe.</p>
            <p>For the best experience, local delivery options, and accurate pricing, please shop on our European store.</p>
            <a class="button" href="https://creative-hut.ie">Go to the European Store</a>
          </div>
        </div>
      `;
      document.body.insertAdjacentHTML('beforeend', popupHTML);

      document.querySelector('.countryPopup span').addEventListener('click', () => {
        document.querySelector('.countryPopup').remove();
        sessionStorage.setItem('countryPopupShown', 'true');
      });
    } else if (userCountry === 'United States') {
      const popupHTML = `
        <div class="countryPopup open">
          <div class="innerContainer">
            <span style="cursor:pointer;">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48" {% if class %}class="{{ class }}"{% endif %}>
            	<path d="M 38.982422 6.9707031 A 2.0002 2.0002 0 0 0 37.585938 7.5859375 L 24 21.171875 L 10.414062 7.5859375 A 2.0002 2.0002 0 0 0 8.9785156 6.9804688 A 2.0002 2.0002 0 0 0 7.5859375 10.414062 L 21.171875 24 L 7.5859375 37.585938 A 2.0002 2.0002 0 1 0 10.414062 40.414062 L 24 26.828125 L 37.585938 40.414062 A 2.0002 2.0002 0 1 0 40.414062 37.585938 L 26.828125 24 L 40.414062 10.414062 A 2.0002 2.0002 0 0 0 38.982422 6.9707031 z"/>
              </svg>
            </span>
            <p>🇺🇸 Hi there!</p>
            <p>It looks like you're visiting from the United States.</p>
            <p>For the best experience, local delivery options, and accurate pricing, please shop on our USA store.</p>
            <a class="button" href="https://creative-hut.us">Go to the USA Store</a>
          </div>
        </div>
      `;
      document.body.insertAdjacentHTML('beforeend', popupHTML);

      document.querySelector('.countryPopup span').addEventListener('click', () => {
        document.querySelector('.countryPopup').remove();
        sessionStorage.setItem('countryPopupShown', 'true');
      });
    }
  }, 1500);
}

function openCountrypopupTangible(userCountry) {
  const europeanCountries = [
  'Albania', 'Andorra', 'Armenia', 'Austria', 'Azerbaijan', 'Belarus', 'Belgium',
  'Bosnia and Herzegovina', 'Bulgaria', 'Croatia', 'Cyprus', 'Czech Republic',
  'Denmark', 'Estonia', 'Finland', 'France', 'Georgia', 'Germany', 'Greece',
  'Hungary', 'Iceland', 'Ireland', 'Italy', 'Kazakhstan', 'Kosovo', 'Latvia',
  'Liechtenstein', 'Lithuania', 'Luxembourg', 'Malta', 'Moldova', 'Monaco',
  'Montenegro', 'Netherlands', 'North Macedonia', 'Norway', 'Poland', 'Portugal',
  'Romania', 'Russia', 'San Marino', 'Serbia', 'Slovakia', 'Slovenia', 'Spain',
  'Sweden', 'Switzerland', 'Turkey', 'Ukraine', 'Vatican City'
];

  setTimeout(() => {
    if (europeanCountries.includes(userCountry)) {
      const popupHTML = `
        <div class="countryPopup open">
          <div class="innerContainer">
            <span style="cursor:pointer;">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48" {% if class %}class="{{ class }}"{% endif %}>
            	<path d="M 38.982422 6.9707031 A 2.0002 2.0002 0 0 0 37.585938 7.5859375 L 24 21.171875 L 10.414062 7.5859375 A 2.0002 2.0002 0 0 0 8.9785156 6.9804688 A 2.0002 2.0002 0 0 0 7.5859375 10.414062 L 21.171875 24 L 7.5859375 37.585938 A 2.0002 2.0002 0 1 0 10.414062 40.414062 L 24 26.828125 L 37.585938 40.414062 A 2.0002 2.0002 0 1 0 40.414062 37.585938 L 26.828125 24 L 40.414062 10.414062 A 2.0002 2.0002 0 0 0 38.982422 6.9707031 z"/>
              </svg>
            </span>
            <p>Hi there!</p>
            <p>It looks like you're visiting from Europe.</p>
            <p>For the best experience, local delivery options, and accurate pricing, please shop on our European store.</p>
            <a class="button" href="https://creative-hut.ie/collections/tangible">Go to the European Store</a>
          </div>
        </div>
      `;
      document.body.insertAdjacentHTML('beforeend', popupHTML);

      document.querySelector('.countryPopup span').addEventListener('click', () => {
        document.querySelector('.countryPopup').remove();
        sessionStorage.setItem('countryPopupShown', 'true');
      });
    } else if (userCountry === 'United States') {
      const popupHTML = `
        <div class="countryPopup open">
          <div class="innerContainer">
            <span style="cursor:pointer;">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48" {% if class %}class="{{ class }}"{% endif %}>
            	<path d="M 38.982422 6.9707031 A 2.0002 2.0002 0 0 0 37.585938 7.5859375 L 24 21.171875 L 10.414062 7.5859375 A 2.0002 2.0002 0 0 0 8.9785156 6.9804688 A 2.0002 2.0002 0 0 0 7.5859375 10.414062 L 21.171875 24 L 7.5859375 37.585938 A 2.0002 2.0002 0 1 0 10.414062 40.414062 L 24 26.828125 L 37.585938 40.414062 A 2.0002 2.0002 0 1 0 40.414062 37.585938 L 26.828125 24 L 40.414062 10.414062 A 2.0002 2.0002 0 0 0 38.982422 6.9707031 z"/>
              </svg>
            </span>
            <p>🇺🇸 Hi there!</p>
            <p>It looks like you're visiting from the United States.</p>
            <p>For the best experience, local delivery options, and accurate pricing, please shop on our USA store.</p>
            <a class="button" href="https://creative-hut.us/collections/tangible">Go to the USA Store</a>
          </div>
        </div>
      `;
      document.body.insertAdjacentHTML('beforeend', popupHTML);

      document.querySelector('.countryPopup span').addEventListener('click', () => {
        document.querySelector('.countryPopup').remove();
        sessionStorage.setItem('countryPopupShown', 'true');
      });
    }
  }, 1500);
}
